import { useTabs } from "../../context/TabContext";
import { getLocalStorageArrayValue, getLocalStorageValue, updateLocalStorageValue } from "../../utils/localStorageHelper";

const getValueByPath = (obj, path) => path.split('.').reduce((o, p) => (o || {})[p], obj);

export const getProductIdLabel = (productId) =>
  productId === -3
    ? 'Temporary Item'
    : productId === -2
      ? 'Vendor Added'
      : productId === -1
        ? 'Punchout Item'
        : productId > 0
          ? `PS${productId}`
          : '';

export const getGridFilterFieldValues = (columns, rows, filters) => {
  const values = {};
  let rowsToUse = rows;
  columns?.forEach((col) => {
    if (col?.type === 'checkboxSelection') return;
    if (col?.type === 'customSelect' && rows) {
      const categoryFilter = Object.keys(filters).find(f => 
        (f?.toLowerCase()?.includes('category') && !f?.toLowerCase()?.includes('subcategory')) ||
        (f?.toLowerCase()?.includes('department'))
      );

      if(col?.field?.toLowerCase()?.includes("subcategory") && categoryFilter && filters[categoryFilter]?.value?.length > 0){
        // filter subcategory options if category filter is applied
        rowsToUse = rows.filter(row => {
          const rowCategory = row.category ? row.category : row.agoraCategory ? row.agoraCategory : row.department ? row.department : null;
          if(!rowCategory) return true;
          if(typeof rowCategory === 'string') return filters[categoryFilter].value.includes(rowCategory);
          if(typeof rowCategory === 'object' && rowCategory.name) return filters[categoryFilter]?.value?.includes(rowCategory.name);
          return true;
        });
      }
      if (col.path) {
        values[col.field] = Array.from(new Set(rowsToUse.map((row) => getValueByPath(row, col.path))))
          .filter(v => v !== undefined && v !== null && v !== '')
          .map((value) => ({ value }));
      } else if (typeof col.getFilterValues === 'function') {
        const allValues = rowsToUse.flatMap((row) => {
          const vals = col.getFilterValues(row);
          return Array.isArray(vals) ? vals : [];
        });

        values[col.field] = Array.from(new Set(allValues)).filter(v => v !== undefined && v !== null && v !== '').map((v) => ({ value: v }));
      } else
        values[col.field] = Array.from(new Set(rowsToUse.map((row) => row[col.field])))
          .filter((value) => value !== undefined && value !== null && value !== '')
          .map((value) => ({ value }));
    }
  });
  return values;
}

export const filterRows = (rows, quickFilter, columns, customFilter) => {
  if (!quickFilter) return rows;

  const normalizeString = (str) => str?.replace(/[^a-z0-9\s]/gi, '')?.toLowerCase();
  const quickFilterWords = normalizeString(quickFilter).split(/\s+/);

  if (!quickFilterWords.length) return rows;

  return rows.filter((row) =>
    quickFilterWords.every((word) =>
      columns.some((col) => {
        const value = col?.valueGetter ? col.valueGetter({ row }) : row[col.field];
        if (customFilter) return customFilter(col, row, value, word);
        if (Array.isArray(value)) {
          return value.some((element) => normalizeString(String(element))?.includes(word));
        }
        return normalizeString(String(value))?.includes(word);
      })
    )
  );
}

// Restore new or conditional columns to their positions based on closest field
export const reconcileColumnOrder = (savedFieldOrder, defaultFieldOrder) => {
  const currentFieldOrder = [...savedFieldOrder.filter(field => field !== 'actions')];
  defaultFieldOrder.forEach((field, defaultFieldIndex) => {
    if (!currentFieldOrder.includes(field)) {
      if (field === 'actions') return;
      const previousField = defaultFieldOrder.slice(0, defaultFieldIndex).reverse().find(f => currentFieldOrder.includes(f));
      currentFieldOrder.splice(previousField ? currentFieldOrder.indexOf(previousField) + 1 : defaultFieldIndex, 0, field);
    }
  });
  return currentFieldOrder;
}

export const setInitFilters = (setFilters, filterStorageKey, quickFilterKey) => {
  const sessionFilters = loadSavedFilters(filterStorageKey);
  const quickFilter = JSON.parse(localStorage.getItem(quickFilterKey));
  const mergedFilters = { ...sessionFilters };
  if (quickFilter && quickFilter.manager) mergedFilters.manager = quickFilter.manager;
  setFilters(mergedFilters);
}

export const loadSavedFilters = (filterStorageKey) => getLocalStorageValue(filterStorageKey);

export const loadSavedSorts = (sortStorageKey) => getLocalStorageArrayValue(sortStorageKey);

export const updateFilters = (setFilters, filterStorageKey, newFilters) => {
  setFilters(newFilters);
  updateLocalStorageValue(filterStorageKey, newFilters);
};

export const onSortModelChange = (setSortModel, model, sortStorageKey) => {
  setSortModel(model);
  updateLocalStorageValue(sortStorageKey, model);
};

export const GetGridKeys = (gridId) => {
  const { activeTab } = useTabs();

  const baseUrl = window.location.href.split(/[?&]start/)[0];
  const filterStorageKey = `tab-${activeTab.key}-filters-${baseUrl}-${gridId}`;
  const gridKey = `dataGridState-${gridId}`;
  const sortStorageKey = `tab-${activeTab.key}-sort-${baseUrl}-${gridId}`;
  const quickFilterKey = `tab-${activeTab.key}-quickfilter-${baseUrl}-${gridId}`;
  // search text is per field, not per grid - in CustomSelectPanel.jsx the field is added to the key
  const baseSearchTextStorageKey = `tab-${activeTab.key}-custom-select-search-${baseUrl}-${gridId}`;
  const searchKey = `tab-${activeTab.key}-search-${baseUrl}-${gridId}`;

  return { filterStorageKey, gridKey, sortStorageKey, quickFilterKey, baseSearchTextStorageKey, searchKey };
};